import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'classroom_management',
  label: 'Turmas',
  onlyPermission: true
};

export default generateResources(resource);
